
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import moment from 'moment';
import { WEEKDAYS } from '@/util/constant';
import { toLocaleTime, getUtcTime } from '@/util/helper';

interface OpeningHour {
  weekday: number;
  openedAt: string | null;
  closedAt: string | null;
  openedAtMenu: false;
  closedAtMenu: false;
}

@Component
export default class VOpeningHour extends Vue {
  @Prop({ type: String, default: '' }) public title!: string;

  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  public hours: OpeningHour[] = [];

  get weekdays() {
    const days = WEEKDAYS(this.$i18n);

    return days.map((day, index) => {
      return { value: index, text: day };
    });
  }

  public addOpeningHour() {
    this.hours.push({
      weekday: 0,
      openedAt: null,
      openedAtMenu: false,
      closedAt: null,
      closedAtMenu: false,
    });
  }

  public getHours() {
    return this.hours.map((h: OpeningHour) => {
      return {
        ...h,
        openedAt: getUtcTime(h.openedAt!),
        closedAt: getUtcTime(h.closedAt!),
      };
    });
  }

  public setHours(hours: OpeningHour[], overwrite: boolean = false): void {
    if (overwrite) {
      this.hours = [];
    }
    for (const hour of hours) {
      this.hours.push({
        weekday: hour.weekday,
        openedAtMenu: false,
        closedAtMenu: false,
        // @ts-ignore
        openedAt: toLocaleTime(hour.openedAt),
        // @ts-ignore
        closedAt: toLocaleTime(hour.closedAt),
      });
    }
  }

  public removeHour(item: OpeningHour) {
    this.hours.splice(this.hours.indexOf(item), 1);
  }

  public validate(): Promise<boolean> {
    return this.$refs.observer.validate();
  }
}
